// redux/store.js
import React from 'react';
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice'; // Ensure you have this file

const store = configureStore({
  reducer: {
    auth: authReducer, // Include your reducers here
  },
});

export default store;